import { StepConnector, stepConnectorClasses } from "@mui/material";

export const CustomConnector = ({ mode, ...props }) => {
  return (
    <StepConnector
      {...props}
      sx={(theme) => ({
        [`& .${stepConnectorClasses.line}`]: {
          height: 2,
          border: 0,
          backgroundColor:
            mode === "order" ? theme.palette.primary.main : "grey.300",
          position: "relative",
        },
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
          top: 17,
        },
        [`&.${stepConnectorClasses.completed}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: theme.palette.primary.main,
          },
        },
        // [`&.${stepConnectorClasses.active}`]: {
        // 	[`& .${stepConnectorClasses.line}`]: {
        // 		backgroundColor:
        // 			mode === "order"
        // 				? theme.palette.primary.main
        // 				: "grey.300",
        // 		position: "relative",
        // 	},
        // },

        [`&.${stepConnectorClasses.active}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: theme.palette.primary.main,
            position: "relative",
          },
        },
      })}
    />
  );
};
